export const NoStatusCode = 999;
export const NetworkConnectionStatusCode = 998;
